





























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteFornecedoresStore from '@/components/Suporte/Store/SuporteFornecedoresStore'
import { validateEmail } from '@/utils/common'

@Component
export default class ComponentModalSuporteFornecedor extends Vue {
  loadSaveOrUpdateFornecedor: boolean = false

  get getSuporteFornecedoresStore() {
    return getModule(SuporteFornecedoresStore, this.$store)
  }

  get loadingSaveOrUpdateFornecedor() {
    return this.loadSaveOrUpdateFornecedor
  }

  set loadingSaveOrUpdateFornecedor(value: boolean) {
    this.loadSaveOrUpdateFornecedor = value
  }

  get showModalFornecedor() {
    return this.getSuporteFornecedoresStore.modal.fornecedor
  }

  set showModalFornecedor(value: boolean) {
    this.getSuporteFornecedoresStore.setModal({ name: 'fornecedor', value })
  }

  $refs!: {
    formFornecedor: any
  }

  formFornecedorRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    email: [(v: any) => this.emailValidation(v)],
    fabricante: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  emailValidation(value: any) {
    if (['', null, undefined].includes(value)) return true
    if (!validateEmail(value)) return 'Formato inválido.'
    return true
  }

  async saveOrUpdateFornecedor() {
    this.loadingSaveOrUpdateFornecedor = true

    if (this.$refs.formFornecedor.validate()) {
      const { mode } = this.getSuporteFornecedoresStore

      const response = await this.getSuporteFornecedoresStore.upsertFornecedor()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Fornecedor ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteFornecedoresStore.getFornecedorPagedSearch(this.getSuporteFornecedoresStore.paginationFornecedor)
        this.showModalFornecedor = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o fornecedor ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateFornecedor = false
  }

  @Watch('showModalFornecedor')
  onChangeShowModalFornecedor(value: boolean) {
    if (!value) {
      this.getSuporteFornecedoresStore.clearFornecedor()
      this.getSuporteFornecedoresStore.setMode({ mode: 'CREATE' })
      this.$refs.formFornecedor.resetValidation()
    }
  }
}
